
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Star, Edit } from "lucide-react";

const RecipeActions = () => {
  return (
    <div className="mt-12 grid md:grid-cols-2 gap-6">
      <Link to="/">
        <Button className="w-full bg-cookie-dark hover:bg-cookie-light text-white flex items-center justify-center gap-2">
          <Star size={18} />
          Get Your Fortune
        </Button>
      </Link>
      <Link to="/create-fortune">
        <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center gap-2">
          <Edit size={18} />
          Create Custom Fortune
        </Button>
      </Link>
    </div>
  );
};

export default RecipeActions;
